module.exports = __webpack_public_path__ + "static/img/son1.99ee44e7.png";